import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 21l-11 -11","key":"svg-0"}],["path",{"d":"M3 14v-4h4","key":"svg-1"}],["path",{"d":"M17 14h4v-4","key":"svg-2"}],["path",{"d":"M10 3l11 11","key":"svg-3"}]]

const IconArrowsDoubleNwSe = createReactComponent('outline', 'arrows-double-nw-se', 'ArrowsDoubleNwSe', __iconNode);

export default IconArrowsDoubleNwSe;